import styled from 'styled-components';

export const RangeSliderContainer = styled.div`
  margin-top: 20px;
  
  .input-range__slider {
    appearance: none;
    background: ${({ theme }) => theme.yellow};
    border: ${({ theme }) => theme.yellow};
    border-radius: 100%;
    cursor: pointer;
    display: block;
    width: 12px;
    height: 12px;
    margin-left: -6px;
    margin-top: -7px;
    outline: none;
    position: absolute;
    top: 50%;
    transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;
  }
  
  .input-range__slider:active {
    transform: scale(1.3);
  }
  
  .input-range__slider:focus {
    box-shadow: 0 0 0 5px rgba(63, 81, 181, 0.2);
  }
  
  .input-range--disabled .input-range__slider {
    background: #cccccc;
    border: 1px solid #cccccc;
    box-shadow: none;
    transform: none;
  }
  
  .input-range__label {
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => theme.black};
    transform: translateZ(0);
    white-space: nowrap;
  }
  
  .input-range__label--min,
  .input-range__label--max {
    display: none;
    bottom: -1.4rem;
    position: absolute;
  }
  
  .input-range__label--min {
    left: 0;
  }
  
  .input-range__label--max {
    right: 0;
  }
  
  .input-range__label--value {
    position: absolute;
    top: -1.8rem;
  }
  
  .input-range__label-container {
    left: -50%;
    position: relative;
  }
  
  .input-range__label--max .input-range__label-container {
    left: 50%;
  }
  
  .input-range__track {
    background: #f1f1f1;
    border-radius: 0.3rem;
    cursor: pointer;
    display: block;
    height: 2px;
    position: relative;
  }
  
  .input-range--disabled .input-range__track {
    background: #eeeeee;
  }
  
  .input-range__track--background {
    left: 0;
    margin-top: -0.15rem;
    position: absolute;
    right: 0;
    top: 50%;
  }
  
  .input-range__track--active {
    background: ${({ theme }) => theme.yellow}
  }
  
  .input-range {
    height: 12px;
    position: relative;
    width: 100%;
  }
`;
